import React from 'react'
import './PrimaryButton.css'
import { Icon } from '@iconify/react'
const PrimaryButton = ({title, action, icon=false}) => {
    return (
        <button className='primary-button' onClick={action}>
            {icon ? <Icon icon={icon}/> :''}
            {title}
        </button>
    )
}

export default PrimaryButton